import { render, staticRenderFns } from "./system.vue?vue&type=template&id=4fb96e15&scoped=true&"
import script from "./system.vue?vue&type=script&lang=js&"
export * from "./system.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb96e15",
  null
  
)

export default component.exports